import React from "react";
import "./ModernGridToolbar.css";

/**
 * Compact grid toolbar (pill filters + title/search card).
 * Separate from FilterPanel — use on pages that need the modern layout only.
 */
const ModernGridToolbar = ({
  isDarkMode = false,
  title,
  totalCount,
  searchValue = "",
  onSearchChange,
  searchPlaceholder = "Search...",
  topFilters = null,
  controlsLeft = null,
  controlsRight = null,
  /** Renders immediately after the title (left side of header) */
  titleAddon = null,
  /** Renders in the panel header, immediately left of the search bar */
  headerControls = null,
  children,
  bodyFlush = false,
}) => {
  const rootClass = `modern-grid-toolbar${isDarkMode ? " modern-grid-toolbar--dark" : ""}`;
  const titleText =
    totalCount !== undefined && totalCount !== null
      ? `${title} (${totalCount})`
      : title;

  return (
    <div className={rootClass}>
      {topFilters && (
        <div className="modern-grid-toolbar__filters">{topFilters}</div>
      )}

      <div className="modern-grid-toolbar__panel">
        <div className="modern-grid-toolbar__header">
          <div className="modern-grid-toolbar__title-row">
            <h2 className="modern-grid-toolbar__title">{titleText}</h2>
            {titleAddon}
          </div>
          {(headerControls || onSearchChange) && (
            <div className="modern-grid-toolbar__header-end">
              {onSearchChange && (
                <div className="modern-grid-toolbar__search-wrap">
                  <label className="modern-grid-toolbar__search">
                    <i
                      className="fa fa-search modern-grid-toolbar__search-icon"
                      aria-hidden="true"
                    />
                    <input
                      type="text"
                      className="modern-grid-toolbar__search-input"
                      value={searchValue}
                      onChange={(e) => onSearchChange(e.target.value)}
                      placeholder={searchPlaceholder}
                      aria-label={searchPlaceholder}
                    />
                  </label>
                </div>
              )}
              {headerControls && (
                <div className="modern-grid-toolbar__header-controls">
                  {headerControls}
                </div>
              )}
            </div>
          )}
        </div>

        {(controlsLeft || controlsRight) && (
          <div className="modern-grid-toolbar__controls">
            <div className="modern-grid-toolbar__controls-left">{controlsLeft}</div>
            <div className="modern-grid-toolbar__controls-right">{controlsRight}</div>
          </div>
        )}

        {children && (
          <div
            className={`modern-grid-toolbar__body${
              bodyFlush ? " modern-grid-toolbar__body--flush" : ""
            }`}
          >
            {children}
          </div>
        )}
      </div>
    </div>
  );
};

/** Unified filter dropdown: icon + label + chevron in one bordered pill */
export const ModernGridToolbarFilterPill = ({
  iconClass,
  children,
  wide = false,
  className = "",
}) => {
  const embeddedDateClass =
    className.includes("modern-grid-toolbar__filter-pill--embedded-date") ||
    (iconClass && /calendar/i.test(iconClass))
      ? " modern-grid-toolbar__filter-pill--embedded-date"
      : "";

  return (
    <div
      className={`modern-grid-toolbar__filter-pill${
        wide ? " modern-grid-toolbar__filter-pill--wide" : ""
      }${embeddedDateClass}${className ? ` ${className}` : ""}`}
    >
      <i className={`${iconClass} modern-grid-toolbar__filter-pill-icon`} aria-hidden="true" />
      <div className="modern-grid-toolbar__filter-pill-select">{children}</div>
    </div>
  );
};

export default ModernGridToolbar;

